/*
 * thuun-header.js
 * ----------------------------------------------------------------------------
 * Mobile overlay open/close for the THUUN header.
 *
 * Sources of truth:
 *   - Overlay structure       -- CLAUDE.md Section 6 (full-screen, two items)
 *   - Register discipline     -- CLAUDE.md Section 13.4 (no animation theatrics)
 *   - Hover/state philosophy  -- CLAUDE.md Section 13.6 Decision 4
 *   - Focus trap requirement  -- CLAUDE.md Section 8 (modal accessibility)
 *
 * Behaviour:
 *   - Hamburger tap        -> open overlay, trap focus, lock body scroll
 *   - Close button tap     -> close overlay, restore focus, restore scroll
 *   - ESC key              -> same as close button
 *   - Overlay backdrop tap -> same as close (only direct hits on the
 *                             overlay surface, not its children)
 *   - Overlay link tap     -> close overlay before the anchor activates,
 *                             so the destination is not hidden behind a
 *                             still-open overlay.
 *
 * Progressive enhancement: with JS disabled the overlay never opens. Phase 1
 * does not ship a no-JS fallback; the two nav items are always reachable
 * via the home Panel 1 CTA (and the sticky mobile CTA once it lands).
 * ----------------------------------------------------------------------------
 */
(function () {
  'use strict';

  var overlay = document.querySelector('[data-thuun-header-overlay]');
  if (!overlay) return;

  var openButton = document.querySelector('[data-thuun-header-open]');
  var closeButton = overlay.querySelector('[data-thuun-header-close]');
  var lastFocused = null;

  function focusableEls() {
    return overlay.querySelectorAll('a[href], button:not([disabled])');
  }

  function open() {
    lastFocused = document.activeElement;
    overlay.hidden = false;
    if (openButton) openButton.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    var first = focusableEls()[0];
    if (first) first.focus();
  }

  function close() {
    overlay.hidden = true;
    if (openButton) openButton.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    if (lastFocused && typeof lastFocused.focus === 'function') {
      lastFocused.focus();
    }
  }

  function onKeydown(e) {
    if (overlay.hidden) return;

    if (e.key === 'Escape') {
      e.preventDefault();
      close();
      return;
    }

    if (e.key === 'Tab') {
      var els = focusableEls();
      if (els.length === 0) return;
      var first = els[0];
      var last = els[els.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  if (openButton) openButton.addEventListener('click', open);
  if (closeButton) closeButton.addEventListener('click', close);

  /* Backdrop tap -- only direct hits on the overlay surface, not its children. */
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) close();
  });

  /* Close before any in-overlay anchor activates, so the destination is
     not hidden behind a still-open overlay. */
  var links = overlay.querySelectorAll('a[href]');
  for (var i = 0; i < links.length; i++) {
    links[i].addEventListener('click', close);
  }

  document.addEventListener('keydown', onKeydown);
})();
